module.exports = __webpack_public_path__ + "img/meetingRoom.1a0bf8f7.png";